export const getScheduleDate = blog => blog?.effectivePublishDate

export const isScheduleDateInFuture = date => date && new Date(date) > new Date()

/** Status from API blog object — trusts server `published` flag (avoids clock skew on UAT). */
export const getBlogStatus = blog => {
  if (!blog) return 'draft'
  if (blog.published === true) return 'published'

  const scheduleDate = getScheduleDate(blog)
  if (scheduleDate && isScheduleDateInFuture(scheduleDate)) return 'scheduled'

  return 'draft'
}

/** Scheduled UI in edit form — user picked a future date without publishing. */
export const isFormScheduled = (published, effectivePublishDate) => {
  if (published) return false
  return isScheduleDateInFuture(effectivePublishDate)
}
